import { UPDATE_EQUIPMENT_SELECTED, SET_EQUIPMENT_SELECTED } from '../actions/EquipmentActions'
import EquipmentInfo from './statics/EquipmentInfo'

const initialState = {
    EquipmentInfo: {
        ...EquipmentInfo,
    }, 
    EquipmentSelected: {
        /*
            <EQUIPMENT-ID>: 0
        */
    }
}

const EquipmentReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_EQUIPMENT_SELECTED:
            return {
                ...state,
                EquipmentSelected: action.newData,
            }
        case UPDATE_EQUIPMENT_SELECTED:
            return {
                ...state,
                EquipmentSelected: {
                    ...state.EquipmentSelected,
                    [action.id]: action.newAmount,
                }
            }
        default:
            return state;
    }
}

export default EquipmentReducer;